import { TradeItem } from "../type";

function convertLiveTradeToTradeItems(liveTrades: any[]): TradeItem[] {
    return liveTrades.map((trade) => ({
        account_number: trade.account_number,
        balance: trade.balance ?? (trade as any).balancebalance,
        created_at: trade.created_at,
        equity: trade.equity,
        id: trade.id,
        order: trade.order,
        order_id: trade.order_id,
        position: (() => {
            try {
                return typeof trade.position === "string" ? JSON.parse(trade.position) : trade.position;
            } catch {
                return trade.position;
            }
        })(),
        position_id: trade.position_id,
        profit: trade.profit,
        time: trade.time,
        updated_at: trade.updated_at,
    }));
}

export { convertLiveTradeToTradeItems };